const actions = {
  setInit(context, bool) {
    context.commit('SET_INIT', bool);
  },
};

export default actions;
